import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom'; // ✅ Import useNavigate
import { ShieldCheck } from 'lucide-react';
import { AuthLayout, FormField, Input, Button } from '../ui';

const OTPPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate(); // ✅ Initialize navigation

  const handleVerify = () => {
    // You can add OTP validation logic here
    navigate('/home'); // ✅ Navigate to Home page
  };

  return (
    <AuthLayout
      eyebrow="KBC · Member access"
      title={<>{t('verify') || 'Verify'} <em className="kbc-serif">code</em>.</>}
      subtitle={t('enterOtp') || 'Enter the 6-digit verification code we sent to your registered contact number.'}
    >
      <div className="space-y-5">
        <FormField label={t('enterOtp') || 'Verification Code'} htmlFor="otp">
          <Input
            id="otp"
            inputMode="numeric"
            placeholder="• • • • • •"
            maxLength={6}
            className="text-center text-lg font-display tracking-[0.6em]"
            leftIcon={<ShieldCheck className="h-[18px] w-[18px]" />}
          />
        </FormField>

        <Button onClick={handleVerify} fullWidth size="lg">
          {t('verify') || 'Verify'}
        </Button>

        <p className="text-center text-sm text-muted">
          {t('resendOtp')}
        </p>
      </div>
    </AuthLayout>
  );
};

export default OTPPage;
